// Resolve the existing public URL through its authoritative artwork IDs.
// Never guess ownership from a display name or a similar-looking slug.
export function resolveArtistEntry(catalogue,profile){
 const publicIds=new Set((profile.artworks||[]).map(w=>`${w.category}:${w.id}`));
 const matches=catalogue.artists.filter(a=>a.artworks.some(w=>publicIds.has(w.id)));
 if(matches.length===0)throw Error('This artist has no approved, available paintings in the gallery yet.');
 if(matches.length!==1)throw Error('This artist URL matches more than one artist account. Please use the individual artist link from the gallery directory.');
 return matches[0].id;
}
